import styled from "styled-components";

import { StyledEditModalContent } from "@pages/Patients/Laboratory/components/EditModal/EditModal.styled";

import {
  alignItemsCenter,
  alpha,
  circle,
  fileAcceptAnimation,
  fileRejectAnimation,
  flexCenter,
  flexColumn,
  flexSpBetween,
  rem,
} from "@styles/Utilities.styled";


export const StyledAddLaboratoryServiceModalContent = styled(StyledEditModalContent)`
  .form {
    margin-top: 1.5rem;
    padding-bottom: 1.5rem;
    
    .form-field {
      margin-bottom: 1rem;
    }

    .form-actions {
      display: flex;
      justify-content: flex-end;
      padding-top: 1rem;
    }
  }

  .batch-content {
    margin-top: 1.5rem;

    .info-section {
      display: flex;
      align-items: flex-start;
      gap: 1rem;
      margin-bottom: 1.5rem;
      padding: 1rem 1rem;
      background-color: #f3f0ff;
      border-radius: var(--border-radius-2);
      border: none;

      .info-icon {
        ${flexCenter}
        ${circle(rem(24))}
        color: #8b5cf6;
        flex-shrink: 0;
        margin-top: 0.125rem;

        svg {
          font-size: ${rem(12)};
          font-weight: 600;
        }
      }

      .info-text {
        font-size: ${rem(14)};
        line-height: 1.5;
        color: #4c1d95;
        font-weight: 400;
        margin: 0;
      }
    }

    .form-actions {
      display: flex;
      justify-content: flex-end;
    }
  }

  .files-wrapper {
    margin-top: 1rem;
    font-size: ${rem(14)};

    .dropzone {
      ${flexCenter}
      height: ${rem(200)};
      padding: 2rem;
      background-color: var(--clr-gray-100);
      border: 2px dashed var(--clr-primary-700);
      border-radius: var(--border-radius-2);
      cursor: pointer;
      transition: all 0.2s ease;

      &.active {
        border: 2px dashed var(--clr-primary-400);
        background-color: ${alpha("var(--clr-primary-400)", 0.05)};
      }

      &.accept {
        background-color: var(--green-3);
        border-color: var(--green-8);
        animation: ${fileAcceptAnimation} 1s var(--ease-slow-start) forwards;
      }

      &.reject {
        background-color: ${alpha("var(--clr-rose)", 0.15)};
        border-color: ${alpha("var(--clr-rose)", 0.8)};
        animation: ${fileRejectAnimation} 0.1s ease-out 4 forwards;
      }

      .text-content {
        ${flexColumn}
        align-items: center;
        gap: 1.5rem;
        text-align: center;

        .p-wrapper {
          ${flexColumn}
          gap: 0.5rem;

          p:first-child {
            font-weight: 500;
            font-size: ${rem(16)};
            color: var(--clr-primary-700);
          }
          
          p:last-child {
            font-size: ${rem(14)};
            color: var(--clr-gray-400);
          }
        }

        .svg-wrapper {
          ${flexCenter}
          ${circle(rem(70))}
          background-color: ${alpha("var(--clr-primary-400)", 0.1)};
        }
      }
    }

    .uploaded-files {
      margin-top: 1.5rem;

      h4 {
        font-weight: 500;
        font-size: ${rem(15)};
        margin-bottom: 1rem;
        color: var(--clr-primary-700);
      }

      ul {
        ${flexColumn}
        gap: 0.75rem;

        li {
          ${flexSpBetween}
          align-items: center;
          gap: 1rem;
          padding: 0.75rem 1rem;
          border: 1px solid var(--clr-gray-175);
          border-radius: var(--border-radius-2);
          background-color: var(--clr-white);

          .content {
            ${alignItemsCenter}
            gap: 0.5rem;
            flex: 1;

            span {
              font-size: ${rem(14)};
              color: var(--clr-primary-700);
              font-weight: 500;
            }
          }
        }
      }
    }
  }

  /* Tab styling overrides */
  .mantine-Tabs-list {
    border-bottom: 1px solid var(--clr-gray-175);
    margin-bottom: 0;
  }

  .mantine-Tabs-tab {
    padding: 1rem 1.5rem;
    font-weight: 500;
    color: var(--clr-gray-400);
    border-bottom: 2px solid transparent;
    transition: all 0.2s ease;

    &[data-active] {
      color: var(--mantine-color-primary-6);
      border-bottom-color: var(--mantine-color-primary-6);
      background-color: transparent;
    }

    &:hover:not([data-active]) {
      color: var(--clr-primary-700);
      background-color: var(--clr-gray-50);
    }
  }

  .mantine-Tabs-panel {
    padding-top: 0;
  }
`;
